export const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

const rad = (x) =>  {
    return x * Math.PI / 180;
}





export const plotDistances = (lat1, lon1, lat2, lon2, r) => {

    //let lat1 = r.geometry.coordinates[1];
    //let lon1 = r.geometry.coordinates[0];

    //let lat2 = marker.position.lat;
    //let lon2 = marker.position.lng;

    let radlat1 = Math.PI * lat1/180
    let radlat2 = Math.PI * lat2/180
    let theta = lon1-lon2
    let radtheta = Math.PI * theta/180
    let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    if (dist > 1) {
        dist = 1;
    }
    dist = Math.acos(dist)
    dist = dist * 180/Math.PI
    dist = dist * 60 * 1.1515
    dist = dist * 1.609344 * 1000 
    //if (unit=="N") { dist = dist * 0.8684 } 
    return {
        r: r,
        distance: dist
    };

}





export const parseFeatures = (locations) =>
{

    let features = {};
    let rotation = 0;
    let key = "";
    let keys = [];
    
    locations.forEach((f) => {
        key = f.geometry.coordinates[1] + "-" + f.geometry.coordinates[0];
        if(
            !keys.find((k) => {
                return key == k
            })
        ) {
            keys.push(key);
            features[key] = [];
        }
        
        rotation = features[key].length * 60;
        features[key].push(
            {rotation: rotation, location: f, draggable: false}
        );

        
    });

    return features;
}

export const parseFileName = (fileName) => {
   

    let lio = fileName.lastIndexOf('.') + 1;
    let name = fileName.slice(0, lio)
    let ext = fileName.slice(lio);

    //name = name.replace(/ /g, '_');
    name = name.replace(/[\s\-–]/g, '_');
    //name = name.replace(/-/g, '_');
    name = name.replace(/[äÄåÅ]+/g, 'a');
    name = name.replace(/[öÖ]+/g, 'o');
    name = name.replace(/[\.,]/g, '');
    name = name + '.' + ext;
    return  name; 
}

export const setRoute = (route, store, calculateBounds) =>
{
    let calcBounds = false;
    if(calculateBounds === true)
    {
        calcBounds = true;
    }

    //console.log("############## setRoute", route)

    //console.log(route)
    store.dispatch('breadcrumbs/addItem',  {type: 'route', text: route.displayName})
    store.dispatch('locations/features', route._id)
                .then((res) => {
                    //console.log("########## res", res)
                    const {focusPoint} = res.data;

                    store.dispatch('routes/setCenter', {
                        lat: focusPoint.coordinates[1],
                        lng: focusPoint.coordinates[0]
                    })

                    store.dispatch('routes/route', res.data);

                    if(calcBounds === true)
                    {
                        store.dispatch('routes/calculateBounds');
                    }

                    //store.dispatch('routes/setOldNames', res.data)

                    let features = parseFeatures(res.data.features)



                    store.dispatch('drawer/setHeader', 'Edit Route');
                    store.dispatch('drawer/setForm', 'editRoute')
                    store.dispatch('routes/setUpdateLocation', false)



                    store.commit('locations/features', features);
                    //store.dispatch('routes/setPreviousVisible', undefined, {root: true});

                    store.dispatch('routes/setVisible', false, {root: true});

                    store.dispatch('lines/lines', route, {root:true})
                    .then((linesRes) => {
                        //console.log("linesRes", linesRes.data)
                        store.commit('lines/lines', linesRes.data)
                        window.vm.$emit('features', features)
                    })
                    .catch((linesErr) => {

                        window.vm.$emit('features', features)

                        console.log(linesErr);
                    })



                    


                })
                .catch((err) => {
                    console.log(err);
                })
}
